import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { AsyncStatus } from '../../constants/async-status';
import LOGIN_FLOW_ACTIONS from './login-action-types';
import POC_VALID_FLOW_ACTIONS from './is-poc-redirect-valid';
import headerToken from '../../constants/header-token';
import ILogin from './login-interface';

const initialState: ILogin = {
    asyncStatus: AsyncStatus.INITIAL,
    pocValidAsyncStatus: AsyncStatus.INITIAL,
    isUserAuthenticated: false,
    id: -1,
    firstName: '',
    lastName: '',
    email: '',
    error: null,
    userId: -1,
    clientId: -1,
    externalId: '',
    userRole: { id: -1, name: '', permissions: [] },
    originalRedirectUrl: '',
    clientInfo: { ecrId: '', organizationName: '' },
};

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        updateLoginStatus: (state: ILogin, { payload }: PayloadAction<any>) => {
            const {
                given_name: firstName,
                family_name: lastName,
                email,
                isUserAuthenticated,
                id: userId,
                externalId,
                identityToken,
                userRole,
                originalRedirectUrl,
                clientInfo,
                clientId,
            } = payload;

            if (isUserAuthenticated) {
                sessionStorage.setItem(
                    headerToken.CORE_API_ACCESS_TOKEN_NAME,
                    identityToken
                );
            }

            return {
                ...state,
                asyncStatus: AsyncStatus.SUCCESS,
                isUserAuthenticated,
                firstName,
                lastName,
                email,
                userId,
                clientId,
                externalId,
                userRole,
                originalRedirectUrl,
                clientInfo,
            };
        },
        authAPIFailed: (state: ILogin, { payload }: PayloadAction<any>) => {
            const { error, isUserAuthenticated } = payload;
            return {
                ...state,
                asyncStatus: AsyncStatus.FAILURE,
                isUserAuthenticated,
                error,
                firstName: payload?.firstName || '',
                lastName: payload?.lastName || '',
            };
        },
        updateOriginalRedirectUrl: (
            state: ILogin,
            { payload }: PayloadAction<string>
        ) =>
            /* eslint-disable arrow-body-style */ /* eslint-disable @typescript-eslint/brace-style */
            {
                return {
                    ...state,
                    originalRedirectUrl: payload,
                };
            },
    },
    extraReducers: {
        [LOGIN_FLOW_ACTIONS.LOGIN_FLOW_PENDING]: (state: ILogin) => {
            state.asyncStatus = AsyncStatus.LOADING;
        },
        [POC_VALID_FLOW_ACTIONS.POC_VALID_FLOW_FULFILLED]: (state: ILogin) => {
            state.pocValidAsyncStatus = AsyncStatus.SUCCESS;
        },
    },
});

export const { updateLoginStatus, authAPIFailed, updateOriginalRedirectUrl } =
    loginSlice.actions;
export default loginSlice.reducer;
